"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EllipsisSlider = exports.TourPanel = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var react_transition_group_1 = require("react-transition-group");
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var TourTypes_1 = require("../Steps/TourTypes");
var inversify_react_1 = require("inversify-react");
var Lightbox_1 = __importDefault(require("@CommonFrontend/Lightbox/Lightbox"));
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var isWelcomeStepProps = function (props) {
    return props.currentStep.stepType === TourTypes_1.TourStepConfigurationType.Welcome;
};
var isTourStepProps = function (props) {
    return props.currentStep.stepType !== TourTypes_1.TourStepConfigurationType.Welcome;
};
var tourPanelClassBuilder = (0, BemBuilder_1.default)("tour-panel");
var TourPanel = function (props) {
    var _a, _b;
    var _c;
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var currentStep = props.currentStep, onClosePanel = props.onClosePanel, onMinimise = props.onMinimise, tourTelemetryId = props.tourTelemetryId;
    var _d = __read((0, react_1.useState)(false), 2), minimise = _d[0], setMinimise = _d[1];
    var handleToggleMinimise = function () {
        var nextMinimise = !minimise;
        if (nextMinimise) {
            onMinimise === null || onMinimise === void 0 ? void 0 : onMinimise();
        }
        setMinimise(nextMinimise);
    };
    var stepContentWrapperElementRef = (0, react_1.useRef)();
    var stepContentElementRef = (0, react_1.useRef)();
    var videoElementRef = (0, react_1.useRef)();
    var lightboxVideoElementRef = (0, react_1.useRef)();
    var _e = __read((0, react_1.useState)(true), 2), playingVideo = _e[0], setPlayingVideo = _e[1];
    var togglePlaying = function () {
        setPlayingVideo(!playingVideo);
    };
    var maybeVideo = currentStep.stepType === TourTypes_1.TourStepConfigurationType.Regular && currentStep.video;
    (0, react_1.useEffect)(function () {
        if (!videoElementRef.current) {
            return;
        }
        if (playingVideo) {
            videoElementRef.current.play();
        }
        else {
            videoElementRef.current.pause();
        }
    }, [playingVideo, videoElementRef, maybeVideo]);
    var _f = __read((0, react_1.useState)(false), 2), lightboxOpen = _f[0], setLightboxOpen = _f[1];
    var videoPreviouslyPlaying = (0, react_1.useRef)();
    var prevFocusRef = (0, react_1.useRef)();
    var openLightbox = function () {
        setLightboxOpen(true);
        videoPreviouslyPlaying.current = playingVideo;
        setPlayingVideo(false);
    };
    var closeLightbox = function () {
        setLightboxOpen(false);
        setPlayingVideo(videoPreviouslyPlaying.current);
        prevFocusRef.current.focus();
    };
    (0, react_1.useEffect)(function () {
        if (!maybeVideo) {
            return;
        }
        if (lightboxOpen) {
            prevFocusRef.current = document.activeElement;
            lightboxVideoElementRef.current.currentTime = videoElementRef.current.currentTime;
            lightboxVideoElementRef.current.focus();
        }
    }, [maybeVideo, lightboxOpen]);
    (0, react_1.useLayoutEffect)(function () {
        var _a;
        var newHeight = (_a = stepContentElementRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
        if (!(0, lodash_1.isNil)(newHeight)) {
            stepContentWrapperElementRef.current.style.height = "".concat(newHeight, "px");
        }
    }, [currentStep, minimise]);
    var isCompletionStep = currentStep.stepType === TourTypes_1.TourStepConfigurationType.Completion;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)(tourPanelClassBuilder(), tourPanelClassBuilder(undefined, currentStep.stepType), tokens_1.darkTheme, (_a = {},
                _a[tourPanelClassBuilder(undefined, "minimised")] = minimise,
                _a)) },
            react_1.default.createElement(kaleidoscope_2.RainbowBar, null),
            react_1.default.createElement(kaleidoscope_1.Panel, { theme: kaleidoscope_1.PanelTheme.Dark, className: tourPanelClassBuilder("content-container") },
                react_1.default.createElement("div", { className: (0, classnames_1.default)(tourPanelClassBuilder("background"), (_b = {},
                        _b[tourPanelClassBuilder("background", "bottom")] = currentStep.stepType === TourTypes_1.TourStepConfigurationType.Completion,
                        _b)) }),
                react_1.default.createElement("div", { className: tourPanelClassBuilder("header") },
                    react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "5", theme: "dark" }, currentStep.title),
                    react_1.default.createElement("div", { className: tourPanelClassBuilder("actions") },
                        !isCompletionStep && (react_1.default.createElement(kaleidoscope_1.IconButton, { icon: minimise ? react_1.default.createElement(icons_1.ChevronUp, null) : react_1.default.createElement(icons_1.ChevronDown, null), type: kaleidoscope_1.ButtonType.Tertiary, tooltip: { content: minimise ? "Restore" : "Minimise", autoStack: true }, onClick: handleToggleMinimise })),
                        (minimise || isCompletionStep) && (react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), type: kaleidoscope_1.ButtonType.Tertiary, tooltip: { content: "Dismiss", autoStack: true }, onClick: function () {
                                onClosePanel();
                            } })))),
                react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: !minimise, className: tourPanelClassBuilder("content"), timeout: kaleidoscope_3.AnimationDuration.Long }, function (_a) {
                    var expandableElementRef = _a.expandableElementRef;
                    return (react_1.default.createElement("div", { ref: expandableElementRef },
                        react_1.default.createElement("div", { className: tourPanelClassBuilder("step-content-wrapper"), ref: stepContentWrapperElementRef },
                            react_1.default.createElement(react_transition_group_1.TransitionGroup, { component: null },
                                react_1.default.createElement(react_transition_group_1.Transition, { in: true, timeout: kaleidoscope_3.AnimationDuration.Short }, function (status) { return (react_1.default.createElement(mobx_react_1.Observer, null, function () {
                                    var _a;
                                    return (react_1.default.createElement("div", { ref: stepContentElementRef, className: (0, classnames_1.default)(tourPanelClassBuilder("step-content"), tourPanelClassBuilder("step-content", status)) },
                                        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", element: "p", theme: "dark", className: tourPanelClassBuilder("description") }, currentStep.description),
                                        currentStep.stepType === TourTypes_1.TourStepConfigurationType.Regular && (react_1.default.createElement("div", { className: (0, classnames_1.default)(tourPanelClassBuilder("video"), (_a = {},
                                                _a[tourPanelClassBuilder("video", "paused")] = !playingVideo,
                                                _a)) },
                                            react_1.default.createElement("video", { className: tourPanelClassBuilder("video-element"), autoPlay: true, loop: true, playsInline: true, muted: true, src: "https://stock-videos.qwilr.com/onboarding/".concat(currentStep.video), ref: videoElementRef }),
                                            react_1.default.createElement("div", { className: tourPanelClassBuilder("video-controls") },
                                                react_1.default.createElement(kaleidoscope_1.IconButton, { size: kaleidoscope_1.ButtonSize.Small, className: tourPanelClassBuilder("video-controls-button"), icon: playingVideo ? react_1.default.createElement(icons_1.Pause, null) : react_1.default.createElement(icons_1.Play, null), onClick: togglePlaying }),
                                                react_1.default.createElement(kaleidoscope_1.IconButton, { size: kaleidoscope_1.ButtonSize.Small, className: tourPanelClassBuilder("video-controls-button"), icon: react_1.default.createElement(icons_1.FullScreen, null), onClick: openLightbox }))))));
                                })); }))),
                        currentStep.stepType === TourTypes_1.TourStepConfigurationType.Regular && isTourStepProps(props) && (react_1.default.createElement(exports.EllipsisSlider, { stepIndex: props.stepIndex, steps: props.steps.filter(function (s) { return s.stepType === TourTypes_1.TourStepConfigurationType.Regular; }), onGoToStep: props.onGoToStep })),
                        currentStep.stepType !== TourTypes_1.TourStepConfigurationType.Regular && !!props.upNextTour && (react_1.default.createElement("div", { className: tourPanelClassBuilder("up-next") },
                            react_1.default.createElement("img", { width: "276", height: "218", className: tourPanelClassBuilder("up-next-thumbnail"), src: "/Assets/Images/DiscoverQwilr/TourThumbnails/".concat(props.upNextTour.image), alt: props.upNextTour.title }),
                            react_1.default.createElement("div", { className: tourPanelClassBuilder("up-next-text-container") },
                                react_1.default.createElement(kaleidoscope_1.Label, { size: "s", theme: "dark", secondary: true }, currentStep.stepType === TourTypes_1.TourStepConfigurationType.Completion ? "Up Next" : "Guided Tour"),
                                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", theme: "dark", strong: true }, props.upNextTour.title)))),
                        currentStep.stepType === TourTypes_1.TourStepConfigurationType.Completion && isTourStepProps(props) && (react_1.default.createElement("div", { className: tourPanelClassBuilder("footer") },
                            react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () {
                                    telemetry.track("Onboarding Panel Restarted", {
                                        onboarding_panel_flow: tourTelemetryId,
                                        onboarding_panel_step: currentStep.step,
                                    });
                                    props.onGoToStep(0);
                                }, type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small },
                                react_1.default.createElement(icons_1.Retry, null),
                                " Restart tour"),
                            !!props.upNextTour && !!props.onStartTour ? (react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () {
                                    telemetry.track("Onboarding Panel Started Up Next", {
                                        onboarding_panel_flow: tourTelemetryId,
                                        onboarding_panel_next_flow: props.upNextTour.telemetryId,
                                    });
                                    props.onFinishTour();
                                    props.onStartTour();
                                } },
                                "Next tour ",
                                react_1.default.createElement(icons_1.ArrowRight, null))) : (react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () {
                                    telemetry.track("Onboarding Panel Finished", {
                                        onboarding_panel_flow: tourTelemetryId,
                                    });
                                    props.onFinishTour();
                                } },
                                react_1.default.createElement(icons_1.ThumbsUp, null),
                                " Got it")))),
                        currentStep.stepType === TourTypes_1.TourStepConfigurationType.Welcome && isWelcomeStepProps(props) && (react_1.default.createElement("div", { className: tourPanelClassBuilder("footer") },
                            react_1.default.createElement(kaleidoscope_1.Button, { onClick: props.onSkip, type: kaleidoscope_1.ButtonType.Tertiary },
                                react_1.default.createElement(icons_1.Skip, null),
                                " Maybe later"),
                            react_1.default.createElement(kaleidoscope_1.Button, { onClick: props.onStartTour },
                                "Begin tour ",
                                react_1.default.createElement(icons_1.ArrowRight, null))))));
                }))),
        currentStep.stepType === TourTypes_1.TourStepConfigurationType.Regular && isTourStepProps(props) && (react_1.default.createElement(Lightbox_1.default, { show: lightboxOpen, onDismiss: closeLightbox },
            react_1.default.createElement("video", { autoPlay: true, loop: true, playsInline: true, muted: true, controls: true, src: "https://stock-videos.qwilr.com/onboarding/".concat((_c = currentStep.videoLarge) !== null && _c !== void 0 ? _c : currentStep.video), ref: lightboxVideoElementRef })))));
};
exports.TourPanel = TourPanel;
var ellipsisClassBuilder = (0, BemBuilder_1.default)("ellipsis-slider");
var EllipsisSlider = function (props) {
    var stepIndex = props.stepIndex, steps = props.steps, onGoToStep = props.onGoToStep;
    var numberOfSteps = steps.length;
    return (react_1.default.createElement("div", { className: ellipsisClassBuilder() },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(ellipsisClassBuilder("container")) }, new Array(numberOfSteps).fill(0).map(function (_, index) {
            var _a;
            return (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: steps[index].title, key: index },
                react_1.default.createElement("button", { className: (0, classnames_1.default)(ellipsisClassBuilder("ellipsis"), (_a = {},
                        _a[ellipsisClassBuilder("ellipsis", "current")] = index === stepIndex,
                        _a)), onClick: function () { return onGoToStep(index); } })));
        })),
        react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Primary, onClick: function () { return onGoToStep(stepIndex + 1); } },
            stepIndex < numberOfSteps - 1 && (react_1.default.createElement(react_1.default.Fragment, null,
                "Next ",
                react_1.default.createElement(icons_1.ArrowRight, null))),
            stepIndex === numberOfSteps - 1 && (react_1.default.createElement(react_1.default.Fragment, null,
                "Done ",
                react_1.default.createElement(icons_1.Tick, null))))));
};
exports.EllipsisSlider = EllipsisSlider;
